module.exports = __webpack_public_path__ + "static/media/bill.c1a4218a.png";